module.exports = __webpack_public_path__ + "img/vue.724332c5.svg";